const navLinks = [
  { label: 'Início', href: '#inicio' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Áreas de Atuação', href: '#areas' },
  { label: 'Como Funciona', href: '#como-funciona' },
  { label: 'Contato', href: '#contato' },
];

const WA_LINK = 'https://wa.me/5547984929295?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20a%20advogada.';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-ink-black text-white/70">
      {/* CTA Banner */}
      <div className="bg-chestnut/15 border-b border-white/10 py-10">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="font-serif text-white text-xl font-semibold mb-1">Precisa de orientação jurídica?</p>
            <p className="text-white/55 font-sans text-sm">Entre em contato agora e dê o primeiro passo.</p>
          </div>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center gap-2 bg-burnt-peach hover:bg-burnt-peach-light text-white font-sans font-medium px-7 py-3.5 rounded-full transition-all duration-200 whitespace-nowrap text-sm flex-shrink-0"
          >
            <i className="ri-whatsapp-line text-base"></i>
            Falar pelo WhatsApp
          </a>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid md:grid-cols-3 gap-10 pb-10 border-b border-white/10">
          {/* Brand */}
          <div>
            <div className="mb-5">
              <p className="font-serif font-semibold text-white text-lg leading-tight">Leide Gonçalves</p>
              <p className="text-burnt-peach font-sans text-xs tracking-[0.18em] uppercase mt-0.5">Advocacia</p>
            </div>
            <p className="text-white/45 font-sans text-xs leading-relaxed mb-5">
              Atendimento especializado em Direito de Família e Sucessões, com humanidade, ética e comprometimento.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/adv.leidegoncalves/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-burnt-peach/25 rounded-full transition-colors duration-200 cursor-pointer"
                aria-label="Instagram Leide Gonçalves Advocacia"
              >
                <i className="ri-instagram-line text-white/60 text-base"></i>
              </a>
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-burnt-peach/25 rounded-full transition-colors duration-200 cursor-pointer"
                aria-label="WhatsApp Leide Gonçalves Advocacia"
              >
                <i className="ri-whatsapp-line text-white/60 text-base"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 id="footer-links">
              <a href="#inicio" onClick={(e) => handleNavClick(e, '#inicio')} className="font-serif text-white font-semibold text-sm mb-5 block">
                Links Rápidos
              </a>
            </h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-white/45 hover:text-burnt-peach font-sans text-xs transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-serif text-white font-semibold text-sm mb-5">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-2-line text-burnt-peach text-sm"></i>
                </div>
                <p className="text-white/55 font-sans text-xs leading-relaxed">
                  Atendimento presencial em<br />Blumenau e Porto Alegre
                </p>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-burnt-peach text-sm"></i>
                </div>
                <a href={WA_LINK} target="_blank" rel="noopener noreferrer nofollow" className="text-white/55 hover:text-burnt-peach font-sans text-xs transition-colors cursor-pointer">
                  +55 47 98492-9295
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-instagram-line text-burnt-peach text-sm"></i>
                </div>
                <a
                  href="https://www.instagram.com/adv.leidegoncalves/"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-white/55 hover:text-burnt-peach font-sans text-xs transition-colors cursor-pointer"
                >
                  @adv.leidegoncalves
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-white/25 font-sans text-xs text-center md:text-left">
            <p>&copy; {new Date().getFullYear()} Leide Gonçalves Advocacia. Todos os direitos reservados.</p>
            <p className="mt-1">OAB/SC nº 48.826</p>
          </div>
          <a
            href="https://startdigital1.com.br"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-white/25 hover:text-burnt-peach font-sans text-xs text-center transition-colors duration-200 cursor-pointer"
          >
            Desenvolvido por Start Digital
          </a>
        </div>
      </div>
    </footer>
  );
}
